module.exports = __webpack_public_path__ + "bb993acee9fad9c3b238cc76fdaac309.pdf";